import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { PrivateComponent } from './private.component';
import { PrivateHomeComponent } from './private-home/private-home.component';
import { PrivateRoutingModule } from './private-routing.module';
import { TranslateModule } from '../services/translate/translate.module';
import { TranslateService } from '../services/translate/translate.service';
import { CoreModule } from '../core/core.module';
import { SearchDocumentsComponent } from './documents/search-documents/search-documents.component';
import { FormsModule } from '@angular/forms';
import { CompaniesListsComponent } from './companies-lists/companies-lists.component';
import { DashboardSupplierComponent } from './private-home/dashboard-supplier/dashboard-supplier.component';
import { DashboardBuyerComponent } from './private-home/dashboard-buyer/dashboard-buyer.component';
import { DashboardFinancierComponent } from './private-home/dashboard-financier/dashboard-financier.component';
import { ReactiveFormsModule } from '@angular/forms';
import { UploadModule } from './files-upload/upload.module';
import { SearchCompaniesComponent } from './companies/search-companies/search-companies.component';
import { EditCompanyComponent } from './companies/edit-company/edit-company.component';
import { CompanyDetailsComponent } from './companies/company-details/company-details.component';
import { DashboardOperatorComponent } from './private-home/dashboard-operator/dashboard-operator.component';
import { LoggerUserDataChangedNotificationService } from '../services/logged-user-data-changed-notification/logged-user-data-changed-notification.service';
import { FinancierCompaniesComponent } from './financier-companies/financier-companies.component';
import { FinancialMovementsModule } from './documents/financial-movements/financial-movements.module';
import { ContractsInCompanyModule } from '../shared-components/contracts-in-company/contracts-in-company.module';

import { DesignSystemComponent } from './design-system/design-system.component';
import { ButtonsComponent } from './design-system/buttons/buttons.component';
import { IconButtonsComponent } from './design-system/icon-buttons/icon-buttons.component';
import { InputsComponent } from './design-system/inputs/inputs.component';
import { CheckboxesComponent } from './design-system/checkboxes/checkboxes.component';
import { RadiosComponent } from './design-system/radios/radios.component';
import { SwitchesComponent } from './design-system/switches/switches.component';
import { MenusComponent } from './design-system/menus/menus.component';
import { SelectsComponent } from './design-system/selects/selects.component';
import { InputsFormComponent } from './design-system/inputs-form/inputs-form.component';
import { DatePickersComponent } from './design-system/date-pickers/date-pickers.component';
import { InputsValidationComponent } from './design-system/inputs-validation/inputs-validation.component';
import { ReadonlyComponent } from './design-system/readonly/readonly.component';
import { DashboardCardComponent } from './private-home/dashboard-card/dashboard-card.component';
import { FormComponentsExampleComponent } from './design-system/form-components-example/form-components-example.component';
import { FormComponentsShowcaseComponent } from './design-system/form-components-showcase/form-components-showcase.component';
import { ResourcesManagerShowcaseComponent } from './design-system/resources-manager-showcase/resources-manager-showcase.component';
import { FAQManagerShowcaseComponent } from './design-system/faq-manager-showcase/faq-manager-showcase.component';
import { FaqShowcaseModule } from './design-system/faq-showcase/faq-showcase.module';
import { ToasterShowcaseComponent } from './design-system/toaster-showcase/toaster-showcase.component';
import { ModalsShowcaseComponent } from './design-system/modals-showcase/modals-showcase.component';
import { SliderShowcaseComponent } from './design-system/slider-showcase/slider-showcase.component';
import { UserNameLabelComponent } from './design-system/user-name-label/user-name-label.component';
import { NavigationDocumentsComponent } from './design-system/navigation-documents/navigation-documents';
import { CustomAccordionModule } from '../shared-components/custom-accordion/custom-accordion.module';
import { CustomTooltipModule } from '../shared-components/custom-tooltip/custom-tooltip.module';
import { CustomTooltipShowcaseComponent } from './design-system/custom-tooltip-showcase/custom-tooltip-showcase.component';
import { DesignSystemAllComponent } from './design-system/all/design-system.component-all';
import { CustomTableShowcaseComponent } from './design-system/custom-table-showcase/custom-table-showcase.component';
import { TablePillCellComponent } from './design-system/custom-table-showcase/components/table-pill-cell.component';
import { CustomAccordionShowcaseComponent } from './design-system/custom-accordion-showcase/custom-accordion-showcase.component';
import { CustomBreadcrumbsShowcaseComponent } from './design-system/custom-breadcrumbs-showcase/custom-breadcrumbs-showcase.component';
import { CustomTabsShowcaseComponent } from './design-system/custom-tabs-showcase/custom-tabs-showcase.component';
import { CustomSegmentedControlShowcaseComponent } from './design-system/custom-segmented-control-showcase/custom-segmented-control-showcase.component';
import { CurrencyFormatterPipe } from '../services/currency-formatter.pipe';
import { DashboardHelperService } from './private-home/dashboard-helper.service';
import { DashboardFactoringTabComponent } from './private-home/dashboard-factoring-tab/dashboard-factoring-tab.component';
import { DashboardMetricCardComponent } from './private-home/dashboard-metric-card/dashboard-metric-card.component';
import { DocumentForecastChartComponent } from './private-home/document-forecast-chart/document-forecast-chart.component';

@NgModule({
	imports: [
		NgxChartsModule,
		CommonModule,
		CoreModule,
		FormsModule,
		ReactiveFormsModule,
		TranslateModule,
		PrivateRoutingModule,
		UploadModule,
		ContractsInCompanyModule,
		CustomAccordionModule,
		CustomTooltipModule,
		FinancialMovementsModule,
		FaqShowcaseModule,
	],
	declarations: [
		PrivateComponent,
		PrivateHomeComponent,
		SearchDocumentsComponent,
		CompaniesListsComponent,
		SearchCompaniesComponent,
		EditCompanyComponent,
		CompanyDetailsComponent,
		DashboardSupplierComponent,
		DashboardBuyerComponent,
		DashboardFinancierComponent,
		DashboardOperatorComponent,
		DashboardFactoringTabComponent,
		DashboardMetricCardComponent,
		DocumentForecastChartComponent,
		FinancierCompaniesComponent,
		DashboardCardComponent,
		DesignSystemComponent,
		DesignSystemAllComponent,
		ButtonsComponent,
		IconButtonsComponent,
		InputsComponent,
		CheckboxesComponent,
		RadiosComponent,
		SwitchesComponent,
		MenusComponent,
		SelectsComponent,
		InputsFormComponent,
		DatePickersComponent,
		InputsValidationComponent,
		FormComponentsExampleComponent,
		FormComponentsShowcaseComponent,
		ReadonlyComponent,
		ResourcesManagerShowcaseComponent,
		FAQManagerShowcaseComponent,
		ToasterShowcaseComponent,
		ModalsShowcaseComponent,
		SliderShowcaseComponent,
		CustomTooltipShowcaseComponent,
		CustomAccordionShowcaseComponent,
		CustomBreadcrumbsShowcaseComponent,
		CustomTabsShowcaseComponent,
		CustomSegmentedControlShowcaseComponent,
		UserNameLabelComponent,
		NavigationDocumentsComponent,
		CustomTableShowcaseComponent,
		TablePillCellComponent,
	],
	providers: [TranslateService, LoggerUserDataChangedNotificationService, CurrencyFormatterPipe, DashboardHelperService],
})
export class PrivateModule {}
